import React from 'react'
import {
    Container,
    Divider,
    Grid,
    Header,
    List,
    Segment,
    Icon
} from 'semantic-ui-react'


const Footer = () => (
    <div >
        <Segment inverted vertical style={{ margin: '6em 0em 0em', padding: '1em 0em' }}>
            <Container textAlign='center'>
                <Grid divided inverted stackable>
                    <Grid.Column >
                        <Header inverted as='h4' content='Herka Trya Fitra' />
                        <p>
                            Portfolio online sederhana dan responsif menggunakan ReactJs <br />
                            dibuat penuh cinta dan jarang mandi pagi
                        </p>
                    </Grid.Column>
                </Grid>

                <Divider inverted section />

                <List horizontal inverted divided link size='small'>
                    <List.Item>
                        <a href="https://github.com/herkahahaha" target="_blank/rel-noopener">
                            <Icon link name='github' size='big' style={{ color: 'white' }} />
                        </a>
                        Github
                    </List.Item>
                    <List.Item >
                        <a href="https://dribbble.com/herkahahaha" target="_blank/rel-noopener">
                            <Icon link name='dribbble' size='big' style={{ color: 'white' }} />
                        </a>
                        Dribble
                    </List.Item>
                    <List.Item >
                        <a href="https://www.linkedin.com/in/herka-trya-fitra-4aa117133" target="_blank/rel-noopener">
                            <Icon link name='linkedin' size='big' style={{ color: 'white' }} />
                        </a>
                        Linkedin
                    </List.Item>
                </List>
                <List>
                    <span >
                        <a href="https://instagram.com/herkahahaha" style={{ color: "white" }}>My Website</a>   &#169;
                        {new Date().getFullYear()}
                    </span>
                </List>
            </Container>
        </Segment>
    </div>
)
export default Footer;
